enum IdDocDataAttribute {
  frontImage = 'front_image',
  backImage = 'back_image',
  selfie = 'selfie',
}

export default IdDocDataAttribute;
